module.exports = __webpack_public_path__ + "static/img/detail-img.26948544.jpg";